import {
  BaseSearchObject,
  SearchHealthCareService,
} from "app/common/Model/SearchObject";
import {
  deleteHealthCareService,
  downloadServiceData,
  downloadTemplate,
  getHealthCareServiceById,
  pagingHealthCareService,
  saveHealthCareService,
} from "app/services/HealthCareService";
import { makeAutoObservable } from "mobx";

import { PAGESIZE_ALL } from "app/common/LocalConst";
import { HealthCareService } from "app/common/Model/HealthCareService";
import {
  downloadCostNorm,
  downloadRevenueAllocation,
  downloadService,
  downloadTemplateServiceDepartment,
  downloadTemplateServiceFee,
  downloadTemplateServiceRoom,
  importClientCardScope,
  importExcelClienrCard,
  importExcelCostNorm,
  importExcelRevenueAllocation,
  importExcelServiceDepartment,
  importExcelServiceRoom,
  importExcelServiceStep,
  importServiceExcel,
  importServiceFeeExcel,
  importServiceWarrantyExcel,
} from "app/services/ImportExcelService";
import moment from "moment";
import { toast } from "react-toastify";

export default class HealthCareServiceStore {
  listAllHealthCareService = [];
  searchHealthCareService = new SearchHealthCareService();
  pageHealthCareService = null;
  selectedHealthCareService = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteHealthCareService = false;
  recentlyUpdated = false;
  openFormUpLoadFile = false;
  selectedRowService = null;
  searchService = {
    ...new BaseSearchObject(),
  };
  openListHealthCare = false;
  selectedService = [];
  page = 1;
  pageSize = 10;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowService = (row) => {
    this.selectedRowService = row;
  };

  setSearchHealthCareService = (searchObject) => {
    this.searchHealthCareService = {
      ...this.searchHealthCareService,
      ...searchObject,
    };
  };
  setPage = (page) => {
    this.page = page;
    this.handleChangeFormSearchService();
  };

  setRowsPerPage = (value) => {
    this.pageSize = value;
    this.page = 1;
    this.handleChangeFormSearchService();
  };
  setSelectedService = (list) => {
    this.selectedService = list;
  };
  setOpenListHealthCare = (state) => {
    this.openListHealthCare = state;
  };

  getAllHealthCareService = () => {
    if (this.listAllHealthCareService?.length === 0 || this.recentlyUpdated) {
      pagingHealthCareService({ pageIndex: 1, pageSize: PAGESIZE_ALL })
        .then(({ data }) => {
          this.listAllHealthCareService = data.content;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu dịch vụ thất bại");
        });
    }
  };

  pagingHealthCareService = () => {
    let {
      serviceTypeId,
      serviceGroupId,
      patientTypeServiceIds,
      departmentApplyIds,
      ...ortherData
    } = this.searchHealthCareService;
    if (Array.isArray(patientTypeServiceIds)) {
      ortherData.patientTypeServiceIds = patientTypeServiceIds.map(
        (item) => item?.id || item
      );
    }
    if (Array.isArray(departmentApplyIds)) {
      ortherData.departmentApplyIds = departmentApplyIds.map((item) => item?.id || item);
    }
    pagingHealthCareService({ ...ortherData }).then(({ data }) => {
      this.pageHealthCareService = data;
    });
  };
  pagingService = () => {
    pagingHealthCareService(this.searchService).then(({ data }) => {
      this.pageHealthCareService = data;
    });
  };

  handleChangeFormSearch = (searchHealthCareService) => {
    this.searchHealthCareService = {
      ...this.searchHealthCareService,
      ...searchHealthCareService,
    };
    this.pagingHealthCareService();
  };

  handleChangeFormSearchService = (searchService) => {
    this.searchService = { ...this.searchService, ...searchService };
    this.pagingService();
  };

  handleOpenFormCreateOrEdit = (healthCareServiceId) => {
    if (Boolean(healthCareServiceId)) {
      getHealthCareServiceById(healthCareServiceId)
        .then(({ data }) => {
          let { serviceRooms } = data;
          let formatServiceRooms =
            serviceRooms &&
            serviceRooms?.length > 0 &&
            serviceRooms?.map((el) => ({
              ...el,
              department: el?.room?.department,
            }));
          this.selectedHealthCareService = {
            ...data,
            serviceRooms: formatServiceRooms || [],
          };
          this.openFormCreateOrEdit = true;
        })
        .catch(function (error) {
          console.error(error);
          toast.error("Lấy dữ liệu không thành công");
        });
    } else {
      this.selectedHealthCareService = new HealthCareService();
      this.openFormCreateOrEdit = true;
    }
  };

  saveHealthCareService = async (healthCareService, { setSubmitting }) => {
    return await saveHealthCareService(healthCareService)
      .then(() => {
        this.selectedHealthCareService = null;
        toast.success("Lưu dịch vụ thành công!");
        this.pagingHealthCareService();
        this.handleClosePopup();
        this.recentlyUpdated = true;
        this.listAllHealthCareService = [];
      })
      .catch(function (error) {
        console.error(error);
        let message = "Lưu dịch vụ thất bại!";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      })
      .finally(function () {
        setSubmitting(false);
      });
  };

  updateHealthCareService = async (healthCareService, { setSubmitting }) => {
    return await saveHealthCareService(healthCareService)
      .then(() => {
        this.selectedHealthCareService = null;
        toast.success("Cập nhật dịch vụ thành công!");
        this.pagingHealthCareService();
        this.recentlyUpdated = true;
        this.handleClosePopup();
      })
      .catch(function (error) {
        console.error(error);
        let message = "Cập nhật dịch vụ thất bại!";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      })
      .finally(function () {
        setSubmitting(false);
      });
  };

  handleDeleteHealthCareService = (healthCareServiceId) => {
    this.selectedHealthCareService = { id: healthCareServiceId?.id };
    this.openConfirmDeleteHealthCareService = true;
  };

  handleConfirmDeleteHealthCareService = () =>
    deleteHealthCareService(this.selectedHealthCareService?.id)
      .then(() => {
        if (
          this.searchHealthCareService.pageIndex > 1 &&
          this.pageHealthCareService?.content?.length === 1
        ) {
          this.searchHealthCareService.pageIndex -= 1;
        }
        toast.success("Xóa dịch vụ công!");
        this.recentlyUpdated = true;
        this.pagingHealthCareService();
        this.handleClosePopup();
      })
      .catch(function (error) {
        console.error(error);
        toast.error("Xóa dịch vụ thất bại");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteHealthCareService = false;
    this.openFormUpLoadFile = false;
  };

  resetStore = () => {
    this.searchHealthCareService = new SearchHealthCareService();
    this.pageHealthCareService = null;
    this.selectedHealthCareService = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteHealthCareService = false;
    this.searchService = { ...new BaseSearchObject() };
  };

  setSearchHCS = (obj) => {
    this.searchHealthCareService = { ...this.searchHealthCareService, ...obj };
  };

  //for choosing service popup in ChooseServicePopup.jsx
  listHCS = [];
  hcsIdSet = null;

  isValidHCS = (hcs) => {
    if (hcs && hcs?.id) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addHCS = (hcs) => {
    if (!this.isValidHCS(hcs)) return;
    this.listHCS.push(hcs);
    this.hcsIdSet.add(hcs?.id);
  };

  initializeListHCS = (hcss) => {
    this.hcsIdSet = new Set();
    this.listHCS = [];
    if (hcss && hcss?.length > 0) {
      for (let i = 0; i < hcss.length; i++) {
        this.addHCS(hcss[i]);
      }
    }
  };

  removeHCS = (hcs) => {
    if (!this.isValidHCS(hcs)) return;
    if (this.hcsIdSet.has(hcs?.id)) {
      this.hcsIdSet.delete(hcs?.id);
    } else {
      console.error("Element is not exist");
    }
  };

  isExist = (hcs) => {
    if (!this.isValidHCS(hcs)) return;
    return this.hcsIdSet.has(hcs?.id);
  };

  getHCSIdSet = () => {
    return this.hcsIdSet;
  };

  getListHCS = () => {
    const bufferIdSet = new Set();
    const data = [];
    if (this.listHCS && this.listHCS?.length > 0) {
      for (let i = 0; i < this.listHCS.length; i++) {
        const hcs = this.listHCS[i];
        if (this.isExist(hcs) && !bufferIdSet.has(hcs?.id)) {
          data.push(hcs);
          bufferIdSet.add(hcs?.id);
        }
      }
    }
    this.listHCS = data;
    return data;
  };
  handleUpLoadFile = () => {
    this.openFormUpLoadFile = true;
  };
  handleImportExcelService = (file) => {
    importServiceExcel(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportExcelServiceStep = (file) => {
    importExcelServiceStep(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportExcelfee = (file) => {
    importServiceFeeExcel(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportWarrantyPeriod = (file) => {
    importServiceWarrantyExcel(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportServiceRoom = (file) => {
    importExcelServiceRoom(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportCostNorm = (file) => {
    importExcelCostNorm(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportServiceDepartment = (file) => {
    importExcelServiceDepartment(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleImportRevenueAllocation = (file) => {
    importExcelRevenueAllocation(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleClientCardScope = (file) => {
    importClientCardScope(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleClientCard = (file) => {
    importExcelClienrCard(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        // this.handleClosePopup();
        this.pagingHealthCareService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleDownloadTemplate = async () => {
    try {
      const res = await downloadTemplate();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "MAU_NHAP_DANH_MUC_DICH_VU" + ".xlsx");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadTemplateServiceRoom = async () => {
    try {
      const res = await downloadTemplateServiceRoom();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "DS_DICH_VU_KY_THUAT" +
        moment(new Date()).format("DDMMYYYY-HHmm") +
        ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadTemplateServiceFee = async () => {
    try {
      const res = await downloadTemplateServiceFee();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "MAU_GIA_DICH_VU" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadService = async () => {
    try {
      const res = await downloadService();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "MAU_DICH_VU" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadCostNorm = async () => {
    try {
      const res = await downloadCostNorm();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "MAU_DANH_MUC_DINH_MUC" +
        moment(new Date()).format("DDMMYYYY-HHmm") +
        ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadServiceDepartment = async () => {
    try {
      const res = await downloadTemplateServiceDepartment();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "MAU_DICH_VU_CO_SO" +
        moment(new Date()).format("DDMMYYYY-HHmm") +
        ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };
  handleDownloadRevenueAllocation = async () => {
    try {
      const res = await downloadRevenueAllocation();
      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "MAU_DICH_VU_PHAN_BO_DOANH_THU" +
        moment(new Date()).format("DDMMYYYY-HHmm") +
        ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };

  handleExport = async (searchObj) => {
    try {
      const response = await downloadServiceData(searchObj);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DANH_SACH_DICH_VU.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };
}
